<script setup lang="ts">
import { computed } from 'vue'
import { pageCanMoveNext, pageCanMovePrevious, pageCount } from '@/models/credit-search/selection'

defineOptions({ name: 'CreditSearchPaginationControls' })

const props = defineProps<{
  idPrefix: 'course' | 'subject'
  offset: number
  limit: number
  total: number
  loading: boolean
}>()

const emit = defineEmits<{
  previous: []
  next: []
}>()

const currentPage = computed(() => Math.floor(Math.max(0, props.offset) / Math.max(1, props.limit)) + 1)
const totalPages = computed(() => pageCount(props.total, props.limit))
const canPrevious = computed(() => pageCanMovePrevious(props.offset))
const canNext = computed(() => pageCanMoveNext(props.offset, props.limit, props.total))
const previousId = computed(() => props.idPrefix === 'course' ? 'coursePagePrevBtn' : 'subPagePrevBtn')
const nextId = computed(() => props.idPrefix === 'course' ? 'coursePageNextBtn' : 'subPageNextBtn')
</script>

<template>
  <div class="flex pagination-controls">
    <button
      :id="previousId"
      class="btn btn-secondary me-auto"
      :class="{ invisible: !canPrevious }"
      :disabled="loading || !canPrevious"
      type="button"
      @click="emit('previous')"
    >Previous Page</button>
    <span :id="`${idPrefix === 'course' ? 'course' : 'subject'}PageIndex`" class="me-auto">
      Page {{ currentPage }}/{{ totalPages }}
    </span>
    <button
      :id="nextId"
      class="btn btn-secondary"
      :class="{ invisible: !canNext }"
      :disabled="loading || !canNext"
      type="button"
      @click="emit('next')"
    >Next Page</button>
  </div>
</template>

<style lang="scss" scoped>
.pagination-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.invisible {
  visibility: hidden;
}
</style>
